var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62754 9.21818C4.38389 9.21818 4.14961 9.12447 3.96218 8.94641L1.15082 6.13505C0.78534 5.76957 0.78534 5.17918 1.15082 4.81371C1.51629 4.44823 2.10668 4.44823 2.47216 4.81371L4.61817 6.95972L10.522 1.05585C10.8875 0.690369 11.4779 0.690369 11.8434 1.05585C12.2089 1.42132 12.2089 2.01171 11.8434 2.37719L5.28353 8.93704C5.0961 9.12447 4.86182 9.20881 4.61817 9.20881L4.62754 9.21818Z",
    fill: "#0DC014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanTick);
export default __webpack_public_path__ + "static/media/planTick.caa8d155f7895ef8ab3144e9a3dde1d9.svg";
export { ForwardRef as ReactComponent };